<!-- marquee -->
<div class="row bg-navy space py-1">
    <div class="col-md-12 bg-navy d-inline-flex"> <span class="badge p-2 bg-warning"><i class="fa-solid fa-bullhorn text-sm"></i></span>
        <marquee class="p-1 font-13">
            {{message}}
        </marquee>
    </div>
</div>
<!--/ marquee End -->